<template>
  <v-app>
    <v-container fluid class="bg-color pa-0 fill-height">
      <v-row align="center" justify="center" no-gutters class="fill-height">
        <v-col cols="5" class="d-flex align-center justify-center fill-height">
          <v-card flat color="transparent" width="60%">
            <v-img src="/logo.png" width="260px" class="mb-6" />
            <v-card-title
              class="font-weight-black font-size-20 pa-0 mb-6 text-white"
              >Dein Account ist bereit</v-card-title
            >
            <v-text-field
              color="white"
              variant="outlined"
              bg-color="white"
              base-color="white"
              density="compact"
              v-model="password"
              placeholder="Passwort eingeben"
              type="password"
              hide-details="auto"
              flat
              rounded="xl"
              class="stroke-2 mb-8"
            ></v-text-field>
            <v-text-field
              color="white"
              variant="outlined"
              bg-color="white"
              base-color="white"
              density="compact"
              v-model="password_repeat"
              placeholder="Passwort wiederholen"
              type="password"
              hide-details="auto"
              flat
              rounded="xl"
              class="stroke-2"
            ></v-text-field>
            <v-btn
              block
              rounded="xl"
              flat
              size="large"
              :disabled="password != password_repeat"
              color="#002949"
              class="mt-10 text-none font-size-14 font-weight-bold"
              @click="finishAccount"
              >Jetzt loslegen</v-btn
            >
            <p class="text-red mt-5 text-center" v-if="showError">Sitzung abgelaufen! Wende dich an einen Administrator!</p>
          </v-card>
        </v-col>
        <v-col cols="7" class="pa-0 fill-height">
          <v-card
            width="100%"
            color="#002949"
            height="100vh"
            style="position: relative"
          >
            <v-img
              src="/bg-img.webp"
              width="100%"
              height="100%"
              cover
              style="position: absolute; right: 0; bottom: 0"
            />
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import axios from "axios";
import sha256 from "sha256";

export default {
  name: "GetStarted",
  data() {
    return {
        password: "",
        password_repeat: "",
        showError: false
    };
  },
  methods: {
    async finishAccount() {
      try {
        let result = await axios.post("/api/employees/finish", {
            password: sha256(this.password),
            registrationId: this.$route.params.id
        })
        if(result.data.finished) {
            this.$router.push("/")
        } else {
            this.showError = true
        }
      } catch (e) {
        console.error(e);
      }
    },
  },
};
</script>

<style scoped>
html,
body {
  height: 100%;
  margin: 0;
  overflow: hidden;
}

.fill-height {
  height: 100vh !important;
}
</style>
